import NotFound from './NotFound';
import './NotFound.scss';

export default NotFound;
